export default "__VITE_ASSET__CqKIqFHK__"